import { useContext, useEffect, useState } from "react";
import trans, { isRTL } from "../../../utils";
import { exportContext } from "../../../context/ExportDataContext";
import { useLazyGetVehicleTripsQuery } from "../../../Redux/service/NewReports/Reports";
import { filtrationcontext } from "../../../context/Filtercontext";
import { useLazyGetVehicleTripsSumQuery } from "../../../Redux/service/Summary/Summary";
import AntdTable from "../../antd/Table/Table";
import { toast } from "react-toastify";
import axios from "axios";
import { DistanceUnit, SpeedUnit } from "../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import { useReportTableColumns } from "../ReportColumns/reportColumns";

const TripsSheetTable = ({
  selectedids,
  startDate,
  endDate,
  isShown,
  currentPage,
  setCurrentPage,
  setTotalData,
  sumIds,
}) => {
  const { setFileName, setExportIds, setStartDateE, setEndDateE } =
    useContext(exportContext);
  const {
    Sort,
    setSort: SetSortFilter,
    searchQuery,
    setSearchQuery,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const inf = useSelector((state) => state.users.user);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  const [trigger, { data }] = useLazyGetVehicleTripsQuery();
  const [SumTrigger, { data: sumData }] = useLazyGetVehicleTripsSumQuery();

  const [loading, setLoading] = useState(false);
  const [geoCodes, setGeoCode] = useState({});

  const truncateItem = (text) => {
    const maxLength = 25;
    return text?.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const fetchMultipleGeoCodePosition = async (lat, lon, id, type) => {
    console.log(lat, lon, id, type);
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
      );

      setGeoCode((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          [type]: response.data.display_name,
        },
      }));
    } catch (error) {
      toast.error("Error fetching geocode position:", {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar" ? true : false,
      });
    }
  };

  const knotsToKmPerHour = (knots) => knots * 1.852;

  const convertMillisecondsToTime = (ms) => {
    const totalMinutes = Math.floor(ms / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return isRTL ? `${hours}س ${minutes}د` : `${hours}h ${minutes}m`;
  };

  const columns = [
    {
      title: trans("Vehicle"),
      dataIndex: "deviceName",
      width: 150,
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
      render: (deviceName) => (
        <span className={"table-element-name ps-0"}>{deviceName}</span>
      ),
    },
    {
      title: trans("Group"),
      dataIndex: "groupName",
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
      width: 150,
      render: (groupName) => groupName || trans("Ungrouped Vehicles"),
    },
    {
      title: trans("Start Time"),
      dataIndex: "startTime",
      width: 180,
      sorter: true,
      render: (startTime) => {
        const date = new Date(startTime);
        return (
          <span className="table-element-date">
            {formatDateString(startTime)}
          </span>
        );
      },
    },
    {
      title: trans("Start Address"),
      dataIndex: "startLat",
      width: 250,
      render: (_, record, index) => (
        <span
          className="text-primary cursor"
          onClick={() =>
            fetchMultipleGeoCodePosition(
              record.startLat,
              record.startLon,
              index,
              "start"
            )
          }
          title={geoCodes[index]?.start}
        >
          {geoCodes[index]?.start
            ? truncateItem(geoCodes[index]?.start)
            : trans("Get current address")}
        </span>
      ),
    },
    {
      title: trans("Odometer Start"),
      dataIndex: "startOdometer",
      sorter: true,
      width: 150,
      render: (value) =>
        `${DistanceUnit(value, inf?.attributes?.distanceUnit || "km")}`,
    },
    {
      title: trans("End Date"),
      dataIndex: "endTime",
      width: 180,
      sorter: true,
      render: (endTime) => {
        return (
          <span className="table-element-date">
            {formatDateString(endTime)}
          </span>
        );
      },
    },
    {
      title: trans("End Address"),
      dataIndex: "endLat",
      width: 250,
      render: (_, record, index) => (
        <span
          className="text-primary cursor"
          onClick={() =>
            fetchMultipleGeoCodePosition(
              record.endLat,
              record.endLon,
              index,
              "end"
            )
          }
          title={geoCodes[index]?.end}
        >
          {geoCodes[index]?.end
            ? truncateItem(geoCodes[index]?.end)
            : trans("Get current address")}
        </span>
      ),
    },
    {
      title: trans("End Odometer"),
      dataIndex: "endOdometer",
      sorter: true,
      width: 150,
      render: (value) =>
        DistanceUnit(value, inf?.attributes?.distanceUnit || "km"),
    },
    {
      title: trans("Average Speed"),
      dataIndex: "averageSpeed",
      sorter: true,
      width: 150,
      render: (value) => SpeedUnit(value, inf?.attributes?.speedUnit || "kn"),
    },
    {
      title: trans("Distance"),
      dataIndex: "distance",
      sorter: true,
      width: 150,
      render: (value) =>
        DistanceUnit(value, inf?.attributes?.distanceUnit || "km"),
    },
    {
      title: trans("Duration"),
      dataIndex: "duration",
      width: 120,
      sorter: true,
      render: (value) => convertMillisecondsToTime(value),
    },
    {
      title: trans("Fuel Cost"),
      dataIndex: "fuelCost",
      width: 120,
      sorter: true,
      render: (value) => `${value.toFixed(2)} ${trans("SAR")}`,
    },
  ];
  const visibleColumns = useReportTableColumns(columns);

  useEffect(() => {
    if (isShown && startDate && endDate && selectedids.length > 0) {
      const from = new Date(startDate).toISOString().replace(/:/g, "%3A");
      const to = new Date(endDate).toISOString().replace(/:/g, "%3A");
      setLoading(true);
      SumTrigger(
        {
          from,
          to,
          selectedids: sumIds,
          page: 1,
          pageSize: 5,
        },
        true
      );
      trigger(
        {
          from,
          to,
          selectedids,
          page: currentPage,
          pageSize: limit,
          sortBy: sort.by,
          sortOrder: sort.order,
          search: searchQuery,
        },
        true
      ).finally(() => setLoading(false));
    }
  }, [
    isShown,
    startDate,
    endDate,
    selectedids,
    currentPage,
    limit,
    trigger,
    sort.by,
    sort.order,
    searchQuery,
  ]);

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
      setSearchQuery("");
    };
  }, [SetSortFilter, setSearchQuery]);

  useEffect(() => {
    if (sumData) {
      setTotalData([
        {
          title: "Total Vehicles Tracked",
          number: sumData?.summary.deviceCount,
          type: "vehicles",
        },
        {
          title: "Highest Max Speed",
          number: sumData?.summary.highestMaxSpeed,
          type: "speed",
        },
        {
          title: "Total Distance",
          number: sumData?.summary.totalDistance,
          type: "distance",
        },
        {
          title: "Total Fuel Consumed",
          number: sumData?.summary.totalSpentFuel,
          type: "fuel",
        },
      ]);
      console.log(sumData?.summary.totalSpentFuel);
    }
  }, [data, sumData]);

  useEffect(() => {
    if (data) {
      setFileName("Trips Report");
      setExportIds(selectedids);
      setStartDateE(startDate);
      setEndDateE(endDate);
    }
  }, [data, startDate, endDate, selectedids]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <AntdTable
        columns={visibleColumns}
        dataSource={data?.data || []}
        loading={loading}
        pageSize={limit}
        totalItems={data?.totalCount}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={350}
      />
    </div>
  );
};

export default TripsSheetTable;
